module.exports = __webpack_public_path__ + "static/media/symfony.ed9c8446.svg";